import React from 'react';
import Img from 'img';
import Icon from 'icon';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import s from './infl-pill.module.scss';

function InfluencerPill({ color, name, slug, img, className, ...props }) {
  return (
    <Link
      onClick={e => e.stopPropagation()}
      to={`/influencers/${slug}`}
      className={`${s.root} ${className || ''}`}
    >
      <div className={s.imgWrapper}>
        <Img className={s.img} src={img} alt={img} resize ratio={0.1} />
      </div>
      <span className={s.name}>{name}</span>
      <Icon icon="angle-right" className={s.arrow} />
    </Link>
  );
}

InfluencerPill.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired
};

export default InfluencerPill;
